import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('hotelConfig');
export const actions = helper.createActions('hotelConfig', actionTypes);